import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Mail, Phone, Cake } from '@material-ui/icons';
import { ageCalculator } from '@webapps/utils';
import { formatPhoneNumber } from 'react-phone-number-input';

const Contact = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>
        <FormattedMessage id="student.profil.contact.title" />
      </div>
      {!info?.email?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <div
          className={css({
            width: '100%',
            marginTop: spacing(1),
            marginBottom: spacing(0),
          })}
        >
        <div className={cx(global.infoText, classes.address)}>
          <div style={{ display: 'flex', alignItems: "left" }}>
            <Cake className={global.smallIcon} />
            <div className={global.infoText}>Age :</div>
          </div>
          <div
            className={classes.phone}
          >
            {info?.birthDate ? `${ageCalculator(info?.birthDate)} ans` : 'Non renseigné'}
          </div>
        </div>
          <div className={cx(global.infoText, classes.address)}>
            <div style={{ display: 'flex', alignItems: "left" }}>
              <Mail className={global.smallIcon} />
              <div className={global.infoText}>Adresse e-mail :</div>
            </div>
            <a
              className={classes.phone}
              href={`mailto:${info?.email}`}
              rel="noreferrer"
              target="_blank"
            >
              {info?.email}
            </a>
          </div>
          <div className={classes.address}>
            <div style={{ display: 'flex', alignItems: "left"  }}>
              <Phone className={global.smallIcon} />
              <div className={global.infoText}>Numéro de téléphone :</div>
            </div>
            <a className={classes.phone}>
              {info?.phone ? formatPhoneNumber(info?.phone) : 'Non renseigné'}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    padding: spacing(0, 2.5),
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2),
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    fontFamily: 'Montserrat',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5)
  },
  address: {
    display: 'flex',
    alignItems: 'left',
    marginTop: spacing(0.5),
  },
  phone: {
    color: '#152652',
    marginLeft: spacing(1),
    textDecoration: 'none',
    '@media (max-width: 430px)': {
      marginLeft: spacing(0),
    }
  },
  infoContainer: {
    display: 'flex',
    color: '#152652',
  },
  infotitle: {
    fontWeight: 600,
    marginRight: spacing(1),
  },
});

Contact.propTypes = {
  info: PropTypes.object,
};

export default Contact;
